'use strict';

exports.__esModule = true;
var ITEM_TYPES = exports.ITEM_TYPES = {
  DEFAULT: 'DEFAULT',
  STATIC_PAGE: 'STATIC_PAGE',
  STORES_PRODUCT: 'STORES_PRODUCT',
  FORUM_POST: 'FORUM_POST',
  FORUM_CATEGORY: 'FORUM_CATEGORY'
};